import React from 'react';
import { motion } from 'framer-motion';
import { Package, CheckCircle } from 'lucide-react';
import PageHero from '../components/PageHero';
import CTASection from '../components/CTASection';
import SEO from '../components/SEO';

const OnboardCourier = () => {
  const features = [
    'Hand-carry service',
    'Commercial-flight courier',
    'Door-to-door supervision',
    'Continuous milestone communication',
    'Secure custody at all times',
    'Urgent aircraft-part movements',
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Onboard Courier Services | Aero Time Critical"
        description="Professional hand-carry onboard courier services with continuous supervision and secure custody for urgent, high-value and aircraft-part shipments."
        path="/onboard-courier"
      />
      <PageHero
        badge="HAND-CARRY SERVICES"
        BadgeIcon={Package}
        title="Onboard Courier"
        titleAccent="Services"
        description="For ultra-critical shipments requiring maximum security and speed, our professional couriers hand-carry your consignment door to door with continuous supervision."
        image="https://customer-assets-m6fa6gv7.emergentagent.net/job_cargo-urgent/artifacts/m1cx2ggb_OBC%20pic%201.png"
      />

      <section className="bg-[#F7F9FB] py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <span className="text-[#0089D0] font-semibold tracking-wide uppercase text-sm">Hand-Carry Expertise</span>
              <h2 className="text-3xl md:text-4xl font-bold mt-3 mb-6 text-[#003057]">
                Your Shipment, Never Out of Sight
              </h2>
              <p className="text-[#4A4A4A] mb-8 leading-relaxed">
                Our professional couriers hand-carry your shipment on commercial flights, ensuring it never
                leaves their custody from collection to final delivery — ideal for urgent aircraft parts and
                high-value consignments.
              </p>
              <ul className="space-y-4">
                {features.map((item, index) => (
                  <li key={index} className="flex items-center gap-3">
                    <CheckCircle className="text-[#0089D0] flex-shrink-0" size={22} />
                    <span className="text-[#003057] font-medium">{item}</span>
                  </li>
                ))}
              </ul>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <img
                src="https://customer-assets-m6fa6gv7.emergentagent.net/job_cargo-urgent/artifacts/m1cx2ggb_OBC%20pic%201.png"
                alt="Onboard courier carrying an urgent consignment through an airport terminal"
                className="w-full h-[450px] object-cover rounded-lg shadow-xl"
                loading="lazy"
              />
            </motion.div>
          </div>
        </div>
      </section>

      <CTASection
        title="Ultra-Critical Shipment?"
        description="Contact our team immediately for hand-carry onboard courier solutions"
        buttonText="Request Onboard Courier Quote"
      />
    </div>
  );
};

export default OnboardCourier;
